<template>
<div v-if="team && roster">
    <div class="row">
        <div class="large-12 columns large-centered">
            <table>
                <tbody class="roster" v-if ="roster">
                    <tr>
                        <td width="50"><img class="team-icon" src="/static/imgs/icons/dices.png" alt=""></td>
                        <td width="125">Relances</td>
                        <td width="110">{{roster.reroll_price * 2}} 000</td>
                        <td width="70">{{nbRerolls}}</td>
                        <td width="150">{{nbRerolls * roster.reroll_price * 2}} 000</td>
                        <td width="20" class="action">
                            <button v-if="currentTreasury >= roster.reroll_price *2"
                                    @click="nbRerolls++"
                                    class="action">+</button>
                            <button v-else  class="deactivated action" disabled>+</button>
                        </td>
                        <td  width="50">
                            <button v-if="nbRerolls>0" class="action"
                                    @click="nbRerolls--">-</button>
                            <button v-else class="deactivated action" disabled>-</button>
                        </td>
                    </tr>
                    <tr v-if ="roster.apo_available">
                        <td><img class="team-icon" src="/static/imgs/icons/red-cross.png" alt=""></td>
                        <td>Apothicaire</td>
                        <td>50 000</td>
                        <td>{{apo}}</td>
                        <td>{{apo * 50}} 000</td>
                        <td v-if="!team.apo">
                            <button v-if="apo==0 && currentTreasury >= 50 "
                                    @click="apo=1" class="action">+</button>
                            <button v-else class="deactivated action" disabled>+</button>
                        </td>
                        <td v-else>
                        </td>
                        <td v-if="!team.apo">
                            <button v-if="apo==1" @click="apo=0" class="action">-</button>
                            <button v-else class="deactivated action" disabled>-</button>
                        </td>
                        <td v-else>
                        </td>
                    </tr>
                    <tr>
                        <td><img class="team-icon" src="/static/imgs/icons/coach.png" alt=""></td>
                        <td>Assistants</td>
                        <td>10 000</td>
                        <td>{{assistants}}</td>
                        <td>{{assistants * 10}} 000</td>
                        <td class="action">
                            <button v-if="currentTreasury >= 10" class="action" @click="assistants++">+</button>
                            <button v-else class="deactivated action" disabled>+</button>
                        </td>
                        <td>
                            <button v-if="assistants > 0" class="action" @click="assistants--">-</button>
                            <button v-else class="deactivated action" disabled>-</button>
                        </td>
                    </tr>
                    <tr>
                        <td><img class="team-icon" src="/static/imgs/icons/pom-pom.png" alt=""></td>
                        <td>Pom-pom girls</td>
                        <td>10 000</td>
                        <td>{{pompoms}}</td>
                        <td>{{pompoms * 10}} 000</td>
                        <td class="action">
                            <button v-if="currentTreasury >= 10" class="action" @click="pompoms++">+</button>
                            <button v-else class="deactivated action" disabled>+</button>
                        </td>
                        <td>
                            <button v-if="pompoms > 0" class="action" @click="pompoms--">-</button>
                            <button v-else class="deactivated action" disabled>-</button>
                        </td>
                    </tr>
                    <tr>
                        <td class="sous-total right" colspan="3">Budget Encadrement</td>
                        <td></td>
                        <td class="sous-total">{{totalStuffCost}} 000</td>
                        <td colspan="2"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'

export default {
  name: 'StuffPurchases',
  components: {
    spinner
  },
  props: {
    'roster': {},
    'team': {},
    'currentTreasury': 0
  },
  data () {
    return {
      apo: 0,
      nbRerolls: 0,
      assistants: 0,
      pompoms: 0
    }
  },
  computed: {
    totalStuffCost: function () {
      if (this.roster === null) {
        return 0
      }
      let budgetAnnexe = 0
      budgetAnnexe = this.nbRerolls * this.roster.reroll_price * 2
      budgetAnnexe += this.apo * 50
      budgetAnnexe += this.assistants * 10
      budgetAnnexe += this.pompoms * 10
      return budgetAnnexe
    }
  },
  watch: {
    apo: function (val) {
      this.$emit('updateStuffCost')
    },
    nbRerolls: function (val) {
      this.$emit('updateStuffCost')
    },
    assistants: function (val) {
      this.$emit('updateStuffCost')
    },
    pompoms: function (val) {
      this.$emit('updateStuffCost')
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}
.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}
.wait {
  cursor: wait;
}
</style>



// WEBPACK FOOTER //
// stuff-purchase.vue?2b53ce74